import { DateTime as DateTime$1 } from "../../../components/DateTime/index.js";
import { useRegionTimezone } from "../../Regions/hooks/useRegionTimezone.js";
import { aggregateStatusSummaries } from "../activity-evals/instance/status.js";
import { ActivityEvalStatusSummaryBadge } from "../activity-evals/instance/ActivityEvalStatusSummaryBadge.js";
import { InstancePeriodTrack } from "../activity-evals/instance/InstancePeriodTrack.js";
import { INSTANCE_CARD_STATUS_BORDER, INSTANCE_CARD_STATUS_TAG, instanceCardStatus } from "./instance-card-status.js";
import { isSameCalendarDay } from "./is-same-calendar-day.js";
import { ServicePeriodInstanceEvals } from "./ServicePeriodInstanceEvals.js";
import { useState } from "react";
import { Card, Tag } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/instance/ServicePeriodInstanceCard.tsx
function ServicePeriodInstanceCard({ headerExtra, instance, runtimeActivityEvals }) {
	const timezone = useRegionTimezone(instance.regionId);
	const [nowIso] = useState(() => (/* @__PURE__ */ new Date()).toISOString());
	const status = instanceCardStatus(instance, nowIso);
	const statusTag = INSTANCE_CARD_STATUS_TAG[status];
	const statusSummary = aggregateStatusSummaries((runtimeActivityEvals ?? []).map((item) => item.statusSummary));
	const sameDay = isSameCalendarDay(instance.startsAt, instance.endsAt, timezone);
	return /* @__PURE__ */ jsxs(Card, {
		borderColor: INSTANCE_CARD_STATUS_BORDER[status],
		borderLeft: "md",
		padding: "sm",
		space: "xs",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "gap-xs flex items-start justify-between",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "min-w-0",
					children: [/* @__PURE__ */ jsx("div", {
						className: "text-color-strong font-bold",
						children: instance.name
					}), headerExtra]
				}), /* @__PURE__ */ jsxs("div", {
					className: "gap-xxs flex shrink-0 items-center",
					children: [/* @__PURE__ */ jsx(ActivityEvalStatusSummaryBadge, {
						pending: status === "upcoming",
						statusSummary
					}), /* @__PURE__ */ jsx(Tag, {
						value: statusTag.value,
						variant: statusTag.variant
					})]
				})]
			}),
			instance.description && /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle text-sm",
				children: instance.description
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "gap-xxs flex flex-col",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "gap-xxs flex flex-wrap items-center text-sm",
					children: [
						/* @__PURE__ */ jsx("span", {
							className: "text-color-subtle",
							children: /* @__PURE__ */ jsx(DateTime$1, {
								mode: "date",
								timestamp: instance.startsAt,
								timezone,
								toggleRelativeOnClick: false
							})
						}),
						/* @__PURE__ */ jsx("span", {
							className: "text-color-strong font-medium",
							children: /* @__PURE__ */ jsx(DateTime$1, {
								mode: "time",
								timestamp: instance.startsAt,
								timezone,
								toggleRelativeOnClick: false
							})
						}),
						/* @__PURE__ */ jsx("span", {
							className: "text-color-subtle",
							children: "→"
						}),
						!sameDay && /* @__PURE__ */ jsx("span", {
							className: "text-color-subtle",
							children: /* @__PURE__ */ jsx(DateTime$1, {
								mode: "date",
								timestamp: instance.endsAt,
								timezone,
								toggleRelativeOnClick: false
							})
						}),
						/* @__PURE__ */ jsx("span", {
							className: "text-color-strong font-medium",
							children: /* @__PURE__ */ jsx(DateTime$1, {
								mode: "time",
								timestamp: instance.endsAt,
								timezone,
								toggleRelativeOnClick: false
							})
						}),
						!sameDay && /* @__PURE__ */ jsx(Tag, {
							tooltip: "This window ends the next day",
							value: "Overnight",
							variant: "caution"
						})
					]
				}), /* @__PURE__ */ jsx(InstancePeriodTrack, {
					endsAt: instance.endsAt,
					startsAt: instance.startsAt,
					timezone
				})]
			}),
			/* @__PURE__ */ jsx(ServicePeriodInstanceEvals, {
				activityEvals: instance.activityEvals,
				periodEndsAt: instance.endsAt,
				periodStartsAt: instance.startsAt,
				runtimeActivityEvals,
				timezone
			})
		]
	});
}
//#endregion
export { ServicePeriodInstanceCard };

//# sourceMappingURL=ServicePeriodInstanceCard.js.map